import {applyActionCode, getAuth } from 'firebase/auth'
import {useState, useEffect, useContext} from 'react';
import { useTranslation } from 'react-i18next';
import { SiteType } from './App';


const VerifyEmail = () => {
    const { isPcSite } = useContext(SiteType);
    const { t } = useTranslation();
    const [initCheck, setInitCheck] = useState<boolean>(false);
    const [resultFlag, setResultFlag] = useState<boolean>(false);

    // 初回のレンダリングのみ
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search)
        const oobCode = queryParams.get('oobCode') || ''
        if (oobCode) {
            // メールアドレスの検証
            applyActionCode(getAuth(), oobCode)
            .then(() => {
                setResultFlag(true)
            })
            .catch((error) => {
                console.log(error)
                setResultFlag(false)
            })
            .finally(() => {
                setInitCheck(true);
            })
        }
    }, [])

    const uri = new URL(window.location.href);
    const regex_dev = /dev/;
    const regex_local = /localhost/;
    var href = ""
    if (regex_dev.test(uri.hostname)) {
        href = "https://app-open-dev.ashirase.com/?link=https://ashirase-dev.web.app/?mode%3Dverified&isi=1631484935&ibi=com.ashirase.ashirase.dev&efr=1";
    } else if (regex_local.test(uri.hostname)) {
        href = "http://localhost:3002/?mode=verified";
    } else {
        href = "https://app-open.ashirase.com/?link=https://ashirase-c6f10.web.app/?mode%3Dverified&isi=1631484935&ibi=com.ashirase.ashirase&efr=1";
    }

    if (initCheck) {
        return (
            <>
                <div id={isPcSite ? "formArea" : "formArea-Mobile"}>
                    <h1 className="title" id={isPcSite ? "PC" : "Mobile"}>{t('verifyEmail.title')}</h1>
                    {resultFlag ? (
                        <div id="succeeded">
                            <p>{t('verifyEmail.successMessage')}</p>
                            <p>{t('verifyEmail.successInstruction')}</p>
                            <a href={href}>{t('verifyEmail.returnLink')}</a>
                        </div>
                    ) : (
                        <div id="failed">
                            <p>{t('verifyEmail.errorMessage')}</p>
                            <p>{t('verifyEmail.errorReason')}</p>
                        </div>
                    )}
                </div>
            </>
        )
    } else {
        return <></>
    }
}

export default VerifyEmail;
